import React, { useState, useEffect } from "react";
import classes from "./Deduction.module.css";
import HeaderNav from "../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import Footer from "../../../Components/Footer/Footer";
import { Pen, Trash2 } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import Select from "react-select";
import filter from "../../../Assets/filter.png";
import { useUser } from "../../../UserContext";
import { Eye, Edit, Trash } from 'lucide-react';


const SetupDeduction = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [NewUser, setNewUser] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [currency, setCurrency] = useState("");
  const [currencySearch, setCurrencySearch] = useState("");
  const [showCurrency, setShowCurrency] = useState(false);
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");
  const [reference, setReference] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [bearer, setBearer] = useState('');
  const { user } = useUser();
  const [baseCurrencyCode, setBaseCurrencyCode] = useState('');
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);
  const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(false);
  const [loadingDots, setLoadingDots] = useState(0);

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  const [formData, setFormData] = useState({
    description: "",
    payable_account: "",
    expense_account: "",
  });


  const [editFormData, setEditFormData] = useState({
    date: "",
    currency: "",
    exchange_rate: "",
  });

  const handleChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setEditFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      const { name, value } = eOrName.target;
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        description: formData.description,
        payable_account: formData.payable_account,
        expense_account: formData.expense_account,
      };

      const response = await api.post('/v1/create-deduction-type', withCompanyId(payload));

      // Reset form
      setFormData({
        description: "",
        payable_account: "",
        expense_account: "",
      });
      setIsModalOpen(false);
      // Refresh the list
      fetchDeductionTypes();

      Swal.fire({
        icon: "success",
        title: "Deduction Added",
        text: response.data.message || "Deduction added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Something went wrong.";

      Swal.fire({
        icon: "error",
        title: "Failed to Add Deduction",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };


  const fetchInitialData = async () => {
    const token = localStorage.getItem("authToken");
    try {
      setIsCurrenciesLoading(true);
      const [refRes, currencyRes] = await Promise.all([
        api.get('/v1/generate-sales-invoice-code'),
        api.get('/v1/fetch-all-currencies'),
      ]);
      if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (currencyRes?.data?.data) setCurrencies(currencyRes.data.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsCurrenciesLoading(false);
    }
  };

  const fetchCompanyInfo = async () => {
    const token = localStorage.getItem("authToken");
    try {
      setIsCompanyLoading(true);
        const res = await api.get(`/v1/companies/get-info`);
      const item = Array.isArray(res?.data?.data) ? res.data.data[0] : null;
      const code = (item?.currency_base || '').toString().trim().toUpperCase();
      if (code) setBaseCurrencyCode(code);
    } catch (err) {
      console.error("Failed to fetch company info", err);
    } finally {
      setIsCompanyLoading(false);
    }
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setBearer(authToken);
    if (authToken) {
      fetchInitialData();
    }
  }, []);

  // Set user's base currency as default once currencies are loaded (fallback to NGN)
  useEffect(() => {
    if (!currency && Array.isArray(currencies) && currencies.length > 0) {
      const userBaseCode = (baseCurrencyCode || user?.currency_base || user?.base_currency || user?.baseCurrency || user?.currency_code || user?.settings?.base_currency || '').toString().trim().toUpperCase();

      let preferred = null;
      if (userBaseCode) {
        preferred = currencies.find(cur => String(cur.code).toUpperCase() === userBaseCode);
      }

      const ngn = currencies.find(cur =>
        (cur.code && String(cur.code).toUpperCase() === 'NGN') ||
        (cur.symbol && (String(cur.symbol).includes('₦') || String(cur.symbol).toUpperCase() === 'NGN')) ||
        (cur.country && String(cur.country).toLowerCase().includes('nigeria'))
      );

      const chosen = preferred || ngn || null;
      if (chosen) {
        setCurrency(chosen.id);
        setSelectedCurrencyText(`${chosen.symbol} ${chosen.code} - ${chosen.country}`);
        setFormData(prev => ({ ...prev, currency: chosen.id }));
      }
    }
  }, [currencies, currency, user, baseCurrencyCode]);

  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [expenseAccounts, setExpenseAccounts] = useState([]);
  const [isExpenseAccountsLoading, setIsExpenseAccountsLoading] = useState(false);
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [isPayableAccountsLoading, setIsPayableAccountsLoading] = useState(false);
  const currencyOptions = currencies.map(cur => ({
    value: cur.id,
    label: `${cur.symbol} ${cur.code} - ${cur.country}`,
    currency: cur
  }));

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        date: editFormData.date,
        id: editFormData.currency, // API expects 'id' field
        exchange_rate: editFormData.exchange_rate,
      };

      const response = await api.post('/v1/exchange-rate/update', withCompanyId(payload), { params: { id: selectedLocation.id } });

      setIsNewModalOpen(false);
      setSelectedLocation(null);

      // fetchExchangeRates(); 
      // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Exchange Rate Updated",
        text: response.data.message || "Exchange rate updated successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Failed to update exchange rate.";

      Swal.fire({
        icon: "error",
        title: "Failed to Update Exchange Rate",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const token = localStorage.getItem("authToken");

      const response = await api.get('/v1/salary_deduction/delete', { params: { id: selectedLocation.id } });

      setIsDeleteModalOpen(false);
      setSelectedLocation(null);
      fetchDeductionTypes(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Deduction Deleted",
        text: response.data.message || "Deduction deleted successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete deduction.";

      Swal.fire({
        icon: "error",
        title: "Failed to Delete Deduction",
        text: errorMessage,
      });
    } finally {
      setDeleting(false);
    }
  };

  const openEditModal = (exchangeRate) => {
    setSelectedLocation(exchangeRate);
    setEditFormData({
      date: exchangeRate.date || exchangeRate.Date,
      currency: exchangeRate.currency?.id || exchangeRate.Currency?.id || exchangeRate.currency_id || exchangeRate.Currency_id,
      exchange_rate: exchangeRate.exchange_rate || exchangeRate.Exchange_rate,
    });
    setIsNewModalOpen(true);
  };

  const openDeleteModal = (exchangeRate) => {
    setSelectedLocation(exchangeRate);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Authorization token not found.");
      navigate("/signin");
      return;
    }

    fetchStore();
    fetchDeductionTypes();
    fetchExpenseAccounts();
    fetchPayableAccounts();
    fetchInitialData();
    fetchCompanyInfo();

  }, [navigate]);

  // Animate pulsating ellipses while loading
  useEffect(() => {
    const anyLoading = isCompanyLoading || isCurrenciesLoading;
    if (!anyLoading) {
      setLoadingDots(0);
      return;
    }
    const id = setInterval(() => {
      setLoadingDots(prev => (prev + 1) % 4);
    }, 350);
    return () => clearInterval(id);
  }, [isCompanyLoading, isCurrenciesLoading]);

  const fetchStore = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await api.get('/v1/store');

      if (response.data.status) {
        setStoreOptions(
          response.data.data.map((s) => ({ value: s.id, label: s.store_name }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch stores:", error);
      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    }
  };

  const fetchExpenseAccounts = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return;
    }

    try {
      setIsExpenseAccountsLoading(true);
      const response = await api.get('/v1/get-expense-accounts');

      const accounts = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      setExpenseAccounts(accounts);
    } catch (error) {
      console.error(
        "Failed to fetch expense accounts:",
        error?.response?.data || error.message
      );
    } finally {
      setIsExpenseAccountsLoading(false);
    }
  };

  const fetchPayableAccounts = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return;
    }

    try {
      setIsPayableAccountsLoading(true);
      const response = await api.get('/v1/get-payable-accounts');

      const accounts = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      setPayableAccounts(accounts);
    } catch (error) {
      console.error(
        "Failed to fetch payable accounts:",
        error?.response?.data || error.message
      );
    } finally {
      setIsPayableAccountsLoading(false);
    }
  };

  const fetchDeductionTypes = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const res = await api.get('/v1/get-deduction-type');
      setNewUser(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching deduction types:", err?.response?.data || err.message);
      setError("Failed to fetch deduction types. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getCurrencyName = (currencyId) => {
    const currency = currencies.find(cur => cur.id == currencyId);
    return currency ? `${currency.symbol} ${currency.code} - ${currency.country}` : currencyId;
  };

  const getStoreName = (storeId) => {
    const store = storeOptions.find(option => option.value === storeId);
    return store ? store.label : storeId;
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.PgeContainerDisp}>
        <div className={classes.actionsbtn_On}>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/transactions/sales-invoice/sale")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button
            className={`${classes.btns_New} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
          <button className={`${classes.btns_News} ${classes.greens}`}>
            Add Deductions
          </button>
        </div>

        <header className={classes.FrtHeaderOne}>
          <h2 className={classes.FrtTitleOne}>Manage Deductions</h2>
        </header>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search all entries" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Methods</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>
            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.thrdkad}>
            <div className={classes.kad}>
              <p className={classes.kdptg}>Total Deductions</p>
              <p className={classes.kdptg1}>{NewUser.length}</p>
            </div>

          </div>
          <button
            className={classes.btnssBtnss}
            onClick={() => setIsModalOpen(true)}
          >
            New Deduction
          </button>

        </div>
        <div className={classes.headerforActions}>
          <div className={classes.actionsSideRight}>
          </div>

        </div>

        <div className={classes.newUserCont}>
          <table className={classes.newUserTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Description</th>
                <th>Created At</th>
                <th>Company</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(5).fill().map((_, i) => (
                      <td key={i}><Skeleton height={20} /></td>
                    ))}
                  </tr>
                ))
              ) : NewUser.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>No deduction types found.</td>
                </tr>
              ) : (
                NewUser.map((deduction, index) => (
                  <tr key={deduction.id}>
                    <td style={{ width: '50px' }}>{index + 1}</td>
                    <td style={{ width: '200px' }}>{deduction.description}</td>
                    <td style={{ width: '200px' }}>{deduction.created_at ? new Date(deduction.created_at).toLocaleString() : "—"}</td>
                    <td style={{ width: '120px' }}>{deduction.company_id}</td>
                    <td className={classes.actionsCell}>
                      <div className={classes.actionIcons}>
                        {/* actions left intentionally inert for now */}
                        <Edit size={16} className={classes.editActionIcon} onClick={() => openEditModal(deduction)} />
                        <Trash size={16} className={classes.deleteActionIcon} onClick={() => openDeleteModal(deduction)} />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>

          <div className={classes.paginationContainertxt}>
            <div className={classes.paginationControlstxt}>
              <button>First</button>
              <button className={classes.activation}>1</button>
              <button>Last</button>
              <span className={classes.pageDisplayText}>
                Displaying 1 - {NewUser.length} of {NewUser.length}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Add Currency Modal */}
      {isModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>New Deduction</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className={classes.modalModalBody}>


                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      placeholder="Enter deduction description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Payable Account</label>
                    <select
                      name="payable_account"
                      value={formData.payable_account}
                      onChange={handleChange}
                      required
                      disabled={isPayableAccountsLoading}
                    >
                      <option value="">
                        {isPayableAccountsLoading
                          ? "Loading payable accounts..."
                          : "Select payable account"}
                      </option>
                      {payableAccounts.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.gl_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Expense GL Account</label>
                    <select
                      name="expense_account"
                      value={formData.expense_account}
                      onChange={handleChange}
                      required
                      disabled={isExpenseAccountsLoading}
                    >
                      <option value="">
                        {isExpenseAccountsLoading
                          ? "Loading expense accounts..."
                          : "Select expense account"}
                      </option>
                      {expenseAccounts.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.gl_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Adding..." : "Add Deduction"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Exchange Rate Modal */}
      {isNewModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Edit Exchange Rate</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsNewModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleEditSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Date</label>
                    <input
                      type="date"
                      name="date"
                      value={editFormData.date}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Currency</label>
                    <Select
                      options={currencyOptions}
                      isLoading={currencies.length === 0}
                      placeholder="Select currency"
                      value={
                        currencyOptions.find(
                          (opt) => opt.value === editFormData.currency
                        ) || null
                      }
                      onChange={(option) =>
                        handleEditChange("currency", option.value)
                      }
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Exchange Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      name="exchange_rate"
                      placeholder="Enter Exchange Rate"
                      value={editFormData.exchange_rate}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Updating..." : "Update Exchange Rate"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Exchange Rate Modal */}
      {isDeleteModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalDeleteContent}>
            <div className={classes.modalModalHeader}>
              <h2 style={{ marginBottom: "auto" }}>Delete Deduction</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <div className={classes.modalModalBodyText00}>
              <p>
                Are you sure you want to delete this deduction?
                <br />This action cannot be undone.
              </p>
              <div className={classes.modalFormDelFooter}>
                <button
                  className={classes.ModalDeleteBtn0}
                  onClick={handleDelete}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Delete Deduction"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default SetupDeduction;